import { UserGroupIcon } from "@heroicons/react/outline"
import { ReactElement } from "react"

const socialIcons: { [key: string]: ReactElement } = {
  generic: <UserGroupIcon className="w-4 h-4" />,
  facebook: <UserGroupIcon className="w-4 h-4" />,
  twitter: <UserGroupIcon className="w-4 h-4" />,
  linkedin: <UserGroupIcon className="w-4 h-4" />,
  youtube: <UserGroupIcon className="w-4 h-4" />,
  tiktok: <UserGroupIcon className="w-4 h-4" />,
}

export const getSocialIcon = (key: string): ReactElement => {
  return socialIcons[key] || socialIcons.generic
}
